import { TeamModel } from "./Team";

export class PlaybyplayModel {
    inning: number = 0;
    top: {
        title: string,
        description: string,
        team: TeamModel,
        type: string,
        eventType: string
    }[] = [];
    bottom: {
        title: string,
        description: string,
        team: TeamModel,
        type: string,
        eventType: string
    }[] = [];
    public get inningPositionText(): string {
        const positions = [
            'era',
            'da',
            'era',
            'ta',
            'ta',
            'ta',
            'ma',
            'ava',
            'ena',
            'ma'
        ];
        let n =  this.inning + '';
        let nN = parseInt(this.inning + '');
        let lastNumber = parseInt((n.length > 1 ? n.substring(1) : n));
        lastNumber = lastNumber === 0 ? 10 : lastNumber; 
        return nN > 10 ? 'ava' : positions[lastNumber - 1];
    };
    constructor(obj?: any) {
        if (obj) {
            this.inning = obj.inningCurrent;
            this.top = obj.top.map((i: any) => {
                const team = new TeamModel();
                team.abbrName = i.team;
                return {
                    title: i.title,
                    description: i.description,
                    team: team,
                    type: i.type,
                    eventType: i.event_type
                }
            });
            this.bottom = obj.bottom.map((i: any) => {
                const team = new TeamModel();
                team.abbrName = i.team;
                return {
                    title: i.title,
                    description: i.description,
                    team: team,
                    type: i.type,
                    eventType: i.event_type
                }
            });
        }
    }
}